<template>
  <v-card-actions>
    <v-card-title class="text_box">
      <div v-for="skill in getProjectSkills" :key="skill.id">
        <v-chip color="info" close @click:close="deleteSkill(skill)">
          {{ skill.skill_name }}
        </v-chip>
      </div>
    </v-card-title>
  </v-card-actions>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import DEFAULT_CONSTANTS from "@/Utilites/constants";

export default {
  name: "ProjectSkillView",
  props: ["projectSkillList"],
  computed: {
    ...mapGetters(["getProjectSkills"]),
  },
  methods: {
    ...mapActions([
      "showLoadingProcess",
      "closeLoading",
      "DeleteProjectSkill",
      "showSnackBar",
      "closeSnackBar",
    ]),
    async deleteSkill(value) {
      await this.showLoadingProcess();
      try {
        await this.DeleteProjectSkill({id: value.id});
        await this.closeLoading();
        await this.showSnackBar({
          text: `${value.skill_name} has been removed from Project`,
          color: DEFAULT_CONSTANTS.warn,
        });
      } catch (err) {
        await this.closeLoading();
        await this.showSnackBar({
          text: JSON.stringify(err),
          color: DEFAULT_CONSTANTS.error,
        });
        setTimeout(async () => {
          await this.closeSnackBar();
        }, DEFAULT_CONSTANTS.timeout);
      }
    },
  },
};
</script>

<style scoped>
.text_box {
  background-color: whitesmoke;
  padding: 10px;
  text-align: justify;
  border: 3px solid;
  border-radius: 5px;
}
</style>
